module.exports = __webpack_public_path__ + "img/logo.3cd2b9e0.png";